export default {
  numberWithCommas
};

function numberWithCommas(num) {
  return num.toString().replace(/\./g, ',');
}